// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 792 ? "main" : chunkId) + "." + {"792":"338c754fe02b77fb369d","861":"c1f16103a6fa1ef0e12a","873":"c1f16103a6fa1ef0e12a"}[chunkId] + ".css";
};